import { RootActionTypes } from '../../../stores/types';
import ActionType from '../constants/ActionType';

export default function hideReturnPolicyDeleteConfirmation(): RootActionTypes {
  return {
    type: ActionType.HideReturnPolicyDeleteConfirmation,
  };
}
